import Dropdown from 'components/Dropdown';
import styles from './styles.module.scss';
import { FC, Props } from './typings';
import { useEffect, useState } from 'react';
import HollowButton from 'components/HollowButton';
import Button from 'components/Button';
import workspaceService from 'api/workspaceService';
import ReactDOM from 'react-dom';

const MembershipMoveStructureModal: FC<Props> = ({
  toggle,
  refetch,
  structure,
  member,
}) => {
  const { mutate: moveUser } = workspaceService.useMoveMembershipStructure();

  const [selectedStructureId, setSelectedStructureId] = useState<string | null>(
    null
  );

  const mappedStructure = structure.map((m) => {
    return {
      name: m.Name,
      value: m.Id,
    };
  });

  useEffect(() => {
    if (member.StructureId) {
      setSelectedStructureId(member.StructureId);
      return;
    }

    setSelectedStructureId(structure?.[0]?.Id ?? '');
  }, [member]);

  const handleChange = () => {
    moveUser(
      {
        Id: member.Id,
        ParentId: selectedStructureId ?? '',
      },
      {
        onSuccess: () => {
          refetch();
          toggle();
        },
      }
    );
  };

  return ReactDOM.createPortal(
    <div className={styles.modal}>
      <div className={styles.window}>
        <div className={styles.wrapper}>
          <div className={styles.title}>Edytuj strukturę</div>
          <Dropdown
            list={mappedStructure}
            defaultValue={selectedStructureId}
            disableChange
            onChange={(t) => {
              setSelectedStructureId(t.value);
            }}
          />
          <div className={styles.buttons}>
            <HollowButton onClick={() => toggle()} text="Anuluj" />
            <Button onClick={handleChange} text="Zapisz" />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MembershipMoveStructureModal;
